import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apisiseci } from "../../api";
import { Priority } from "../../../@types/priority";
import { toast } from "react-toastify";

export function usePriorityDelete() {
    const token = localStorage.getItem("gov_access_token_sso");
    const queryClient = useQueryClient();

    return useMutation<Priority, AxiosError<{ detail: string }>, Priority["id"]>({
        mutationFn: async (id) => {
            const response = await apisiseci.delete<Priority>(
                `/cms/prioridades/${id}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async (_, id) => {
            toast.success(`Prioridade removida com sucesso!`);
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: ["priority", "list"] }),
                queryClient.invalidateQueries({ queryKey: ["priority", "details", id] })
            ]);
        },
        onError: (error: AxiosError<{ detail: string }>) => {
            toast.error(error?.response?.data?.detail || "Algo deu errado, tente novamente!");
            console.error(error);
        }
    });
}